'use strict';
import Swiper from 'swiper/bundle';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
// import { Flip } from 'gsap/Flip';
import Cookies from 'js-cookie';
import Player from '@vimeo/player';
gsap.registerPlugin(ScrollTrigger);

function toggle_header_menu() {
  const menu_toggle = document.getElementById('menu-toggle-button');
  const menu_toggle_nav = document.getElementById('menu-toggle-navigation');
  const site_header = document.getElementById('site-header');
  // console.debug(menu_toggle.dataset.status);

  if (menu_toggle != null) {
    menu_toggle.addEventListener('click', (e) => {
      if (menu_toggle.dataset.status != 'open') {
        menu_toggle.dataset.status = 'open';
        menu_toggle_nav.dataset.status = 'open';
        site_header.dataset.navStatus = 'open';
      } else {
        menu_toggle.dataset.status = 'close';
        menu_toggle_nav.dataset.status = 'close';
        site_header.dataset.navStatus = 'close';
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', toggle_header_menu);

function toggle_language() {
  const switcher_form = document.getElementById('switcher-form');
  if (switcher_form == null) return false;

  const lang =
    (window.navigator.languages && window.navigator.languages[0]) ||
    window.navigator.language;

  if (Cookies.get('lang') == null) {
    // Cookies.set('lang', 'ja-JP', { expires: 7 });
    switch (lang) {
      case 'ja':
        Cookies.set('lang', 'ja', { expires: 7 });
        break;
      case 'ja-JP':
        Cookies.set('lang', 'ja', { expires: 7 });
        break;
      default:
        Cookies.set('lang', 'en', { expires: 7 });
        break;
    }
  }
  const current_lang = Cookies.get('lang');
  document.documentElement.lang = current_lang;
  const lang_items = switcher_form.lang;

  switch (current_lang) {
    case 'ja':
      lang_items[0].checked = true;
      break;
    case 'ja-JP':
      lang_items[0].checked = true;
      break;
    default:
      lang_items[1].checked = true;
      break;
  }

  switcher_form.addEventListener('change', function (e) {
    document.documentElement.lang = this.lang.value;
    Cookies.set('lang', this.lang.value, { expires: 7 });
  });
}

function change_tab_slide() {
  const tab_slide_nav = document.getElementById('tab-slide-nav');
  const tab_slide_nav_children = tab_slide_nav ? tab_slide_nav.children : null;
  //if (tab_slide_nav == null) return false;

  function reset_nav_status(list) {
    Array.prototype.forEach.call(list, function (elm) {
      elm.children[0].classList.remove('active');
    });
  }

  function nav_click_change() {
    if (tab_slide_nav_children == null) return false;
    // ナビゲーションの操作で所定のタブに遷移
    Array.prototype.forEach.call(tab_slide_nav_children, function (el) {
      el.children[0].addEventListener('click', function (e) {
        slide_index = this.dataset.slideIndex;
        swiperTab.slideTo(slide_index);
        return false;
      });
    });
  }

  function change_slide(e) {
    if (tab_slide_nav_children == null) return false;
    var index = e.activeIndex;
    // console.debug(tab_slide_nav_children.length);
    if (tab_slide_nav_children.length > 1) {
      reset_nav_status(tab_slide_nav_children);
      tab_slide_nav_children[index].children[0].classList.add('active');
    }
  }

  var slide_index;

  const swiperTab = new Swiper('.swiper-tab', {
    // Optional parameters
    slidesPerView: 1,
    autoHeight: true,

    history: {
      enabled: true,
      key: '#',
      replaceState: true,
    },
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    on: {
      init: nav_click_change,
      slideChange: change_slide,
    },

    breakpoints: {
      768: {
        autoHeight: false,
      },
    },
  });
}

function change_form_focus() {
  const wpcf7_form = document.querySelector('.wpcf7-form');
  if (wpcf7_form == null) return false;

  const wpcf7_form_control = document.querySelectorAll('.wpcf7-form-control');
  wpcf7_form_control.forEach((field) => {
    field.addEventListener('focus', function (e) {
      e.target.parentNode.parentNode.classList.add('focus');
    });
    field.addEventListener('blur', function (e) {
      if (e.target.value === '') {
        e.target.parentNode.parentNode.classList.remove('focus');
      }
    });
  });

  wpcf7_form.addEventListener('submit', function (e) {
    e.submitter.classList.add('sending');
  });
  wpcf7_form.addEventListener('wpcf7submit', function (e) {
    if (e.target.dataset.status === 'sent') {
      wpcf7_form.querySelector('.wpcf7-submit').remove();
    } else {
      wpcf7_form.querySelector('.wpcf7-submit').classList.remove('sending');
    }
  });

  wpcf7_form.addEventListener('change', function (el) {
    if (el.target.value != '') {
      el.target.parentNode.classList.add('active');
    } else {
      el.target.parentNode.classList.remove('active');
    }
  });
}
document.addEventListener('DOMContentLoaded', change_form_focus);

function change_cat_select() {
  const select_cat_form = document.getElementById('select-cat-form');
  if (select_cat_form == null) return false;

  select_cat_form.addEventListener('change', function (e) {
    // console.debug(this.category.value);
    location.href = this.category.value;
    return false;
  });

  // console.debug(select_cat_form.category.options);
}

// const windowHalfHeight = window.innerHeight / 2;
// var timerId,
//   startPos = 0,
//   winScrollTop = 0;
// window.addEventListener('scroll', function (e) {
//   winScrollTop = window.pageYOffset || document.documentElement.scrollTop;
//   // console.debug(winScrollTop);

//   clearTimeout(timerId);
//   timerId = setTimeout(() => {
//     // winScrollTop = window.pageYOffset;
//     // if( windowHalfHeight )
//     if (startPos < winScrollTop) {
//       document.body.dataset.sclollDirection = 'down';
//     } else {
//       document.body.dataset.sclollDirection = 'up';
//     }
//     startPos = winScrollTop;
//   }, 100);
//   return false;
// });

let ticking = false;
let timerId;

function setViewPos() {
  const scrollY = window.scrollY || window.pageYOffset;
  const viewportHeight = window.innerHeight;

  if (scrollY < viewportHeight) {
    document.body.dataset.viewPos = 'first';
  } else {
    document.body.dataset.viewPos = 'other';
  }
}

function onScroll() {
  clearTimeout(timerId);
  timerId = setTimeout(() => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        setViewPos();
        ticking = false;
      });
      ticking = true;
    }
  }, 100);
}
window.addEventListener('scroll', onScroll);

function opening_loading() {
  if (document.body.dataset.loading !== 'loading') return false;

  setTimeout(function () {
    document.body.dataset.loading = 'done';
  }, 300);
}
window.addEventListener('load', opening_loading);

function checkDeviceType() {
  var browserWidth =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth ||
    0;
  return browserWidth < 768 ? 'mobile' : 'pc';
}

function init_video() {
  const video = document.getElementById('about-video');
  if (video === null) return null;

  const deviceType = checkDeviceType();
  // console.debug(deviceType);

  let options_device = {};
  let options_common = {
    loop: true,
    background: true,
    muted: true,
    responsive: true,
    // autoplay: true,
    // controls: false,
    // dnt: true,
  };

  switch (deviceType) {
    case 'mobile':
      options_device = {
        id: 1077572291,
        width: 480,
        height: 720,
        quality: '540p',
      };
      break;
    case 'pc':
      options_device = {
        id: 1077517647,
        width: 1440,
        height: 810,
      };
      break;
  }

  const options = Object.assign({}, options_device, options_common);

  // console.debug(options);

  const vimeoPlayer = new Player('about-video', options);
  return vimeoPlayer;
}

function toBoolean(value) {
  return value === 'true';
}

function filterJobInformation() {
  const jobFilter = document.querySelector('.js-job-filter');
  const jobConents = document.querySelector('.js-job-cotnetns');

  if (jobFilter === null || jobConents === null) return false;

  const jobFilterSelect = jobFilter.querySelectorAll('select');

  function filterArticles() {
    const articles = document.querySelectorAll('.item.recruit-section');

    articles.forEach((article) => {
      let isVisible = true;

      // 選択されたフィルター条件ごとにチェック
      selectedValues.forEach((filter) => {
        const dataAttr =
          filter.id === 'type-of-entry' ? 'data-toe' : 'data-toc';
        const attrValue = article.getAttribute(dataAttr);

        // 空の値は無視（フィルター対象外）
        if (filter.value !== '' && filter.value !== attrValue) {
          isVisible = false; // 条件が合わなければ非表示にする
        }
      });

      // 条件に一致する or フィルターが空なら表示
      if (isVisible) {
        article.classList.remove('hide');
      } else {
        article.classList.add('hide');
      }
    });

    let hideCount = 0;
    articles.forEach((article) => {
      if (article.classList.contains('hide')) {
        hideCount++;
      }
    });

    if (articles.length === hideCount) {
      jobConents.classList.add('empty');
    } else {
      jobConents.classList.remove('empty');
    }
  }

  const filterForm = document.getElementById('filter-form');
  let selectedValues = [];

  filterForm.addEventListener('change', function (e) {
    const targetId = e.target.id;
    const targetValue = e.target.value;

    // すでに同じidがあるかチェック
    const existingItem = selectedValues.find((item) => item.id === targetId);

    if (existingItem) {
      // 既存の値を上書き
      existingItem.value = targetValue;
    } else {
      // なければ追加
      selectedValues.push({
        id: targetId,
        value: targetValue,
      });
    }
    filterArticles();
  });
}

function init() {
  init_video();

  filterJobInformation();

  // data-in-view 属性を持つすべての要素を取得
  const elements = document.querySelectorAll('[data-in-view]');
  elements.forEach((el) => {
    const gsapPin = el.dataset.pin;
    const gsapPinBool = toBoolean(gsapPin);
    // console.debug(gsapPinBool);

    ScrollTrigger.create({
      trigger: el, // 対象要素
      start: 'top center', // ビューポートの80%位置に来たとき
      end: 'bottom+=200 top', // ビューポートの20%位置を出るとき
      pin: gsapPinBool, // .top要素が固定される
      // scrub: 0.2,
      onEnter: () => {
        el.classList.add('view');
        el.classList.remove('hide');
      }, // 画面内に入ったとき
      onLeave: () => {
        if (gsapPinBool === true) {
          el.classList.remove('view');
          el.classList.add('hide');
        }
      },
      onEnterBack: () => {
        if (gsapPinBool === true) {
          el.classList.add('view');
          el.classList.remove('hide');
        }
      }, // スクロールバックで再度入ったとき
      onLeaveBack: () => {
        if (gsapPinBool === true) {
          el.classList.remove('view');
          el.classList.add('hide');
        }
      }, // スクロールバックで再度外れたとき
      // markers: true, // デバッグ用のマーカーを無効に（必要ならtrueに）
    });
  });

  if (document.querySelector('.js-front-wrap')) {
    ScrollTrigger.create({
      trigger: '.js-front-wrap',
      start: 'top top',
      end: 'bottom bottom',
      onEnter: (el) => el.trigger.classList.add('view'),
      onLeave: (el) => el.trigger.classList.remove('view'),
      onEnterBack: (el) => el.trigger.classList.add('view'),
      onLeaveBack: (el) => el.trigger.classList.remove('view'),
      // markers: true, // デバッグ用のマーカーを無効に（必要ならtrueに）
    });
  }

  if (document.querySelector('.js-fullscreen')) {
    ScrollTrigger.create({
      trigger: '.js-fullscreen',
      start: 'top center',
      end: 'bottom bottom',
      onEnter: (el) => el.trigger.classList.add('view'),
      // markers: true, // デバッグ用のマーカーを無効に（必要ならtrueに）
    });
    ScrollTrigger.create({
      trigger: 'body',
      start: 'top top',
      end: 'bottom top',
      onEnter: () => {
        // console.log('ファーストビュー内に入りました');
      },
      onLeaveBack: () => {
        document.querySelector('.js-fullscreen').classList.remove('view');
        document
          .querySelector('.about-section-body__text-wrapper')
          .classList.remove('view');
      },
      // markers: true, // デバッグ用のマーカーを無効に（必要ならtrueに）
    });
  }

  // ページロード時にファーストビュー内か判定
  // if (trigger.isInViewport) {
  //   console.log('ページ読み込み時にファーストビューにいます');
  // }

  const swiperStickyNews = new Swiper('.swiper-sticky-news', {
    loop: true,
    autoplay: {
      delay: 5000,
    },
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  const swiperJournal = new Swiper('.swiper-journal', {
    // Optional parameters
    slidesPerView: 1.4,
    spaceBetween: 34,
    //loop: true,
    // If we need pagination
    scrollbar: {
      el: '.swiper-scrollbar',
    },

    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    breakpoints: {
      480: {
        slidesPerView: 2.2,
        spaceBetween: 40,
      },
      768: {
        slidesPerView: 3.2,
        spaceBetween: 40,
      },
    },
  });

  toggle_language();
  change_tab_slide();
  change_cat_select();
  setViewPos();
}
document.addEventListener('DOMContentLoaded', init);
